<hd-how-it-works
    [user]="user$ | async"
></hd-how-it-works>
